export const editData = {
  data() {
    return {
      productInfo: {},// 当前选择的产品信息
      isDraft:false,//是否是草稿
      timer:{},//邮箱按钮计时
      showAreaText:false,//编辑默认显示文本
      // 限制只能输入今天之前日期
      isAbnormal:'',
      dateOptions: {
        disabledDate: (date) => {
          return date && date.valueOf() > Date.now()
        },
      },
      gradeList:[],//产品方案列表
      additionGradeList:[],//附加险产品方案列表
      regionsArr: [], // 区域数组 省市
      regionsArr2: [], // 区域数组 省
      regionsAll: [],// 区域数组 省市区
      protocolId: "", //对账单的id
      showMol: false, //是否显示影响因子字段
      pageName: "", //页面名称
      addtionSeleted: "",
      INDEX: "",
      tableLoading: false,
      tableLoading1: false,
      policyNameArr: [], // 投保人姓名列表
      insuredNameArr: [], // 被保险人姓名列表
      loading: false,
      submitLoading: false,
      hasAddition: true, // 是否有附加险
      insuranceInfoList: [], //投保资料列表
      insuranceContractList: [], // 保险合同列表
      customerNoticeList: [], //客户告知书列表
      otherInfoList: [], //其他资料列表
      uploadList: "insuranceContractList",
      themeList: ["保险合同", "投保资料", "客户告知书", "其他"],
      themeActive: 0,
      gradeAdditionList: [], // 档次列表
      companyList: [], // 保司名称列表
      productListArr: [], // 产品名称列表
      salesmanList: [], // 出单机构业务员列表
      salesmanListByOrg: [], // 出单机构业务员列表
      groupList: [], // 出单团队列表
      editFlag: "", // 新增还是编辑
      policyInfoList: {}, //保单详情列表
      additionalList: [], // 附加险列表
      fullAdditionalList: [],
      evTimeStamp: "",
      formDataBak:{},
      policyHoderFormBak:{},
      insuredFormDynamicBak:{},
      benefitFormDynamicBak:{},
      formDynamicBak: {
        additional: [

        ],
      },
      reload:false,
      //基础信息
      formData: {
        isAbnormal:'0',//录单类型
        offlineId: "", // 保单id
        companyName: "", // 保险公司
        companyCode:'',// 保司code
        companyId: "", // 保险公司
        productId: "", // 产品Id
        productCode: "", // 产品Code
        programId: "", // 产品方案id
        gradeCode: "", // 档次/计划
        programName: "", // 产品方案
        source:'',//产品来源
        insuranceCategory: "", //保险类别1：人身险；2：财险；3：车险
        productName: "", //产品名称
        fee: "", // 保费(元)
        policyNo: "", // 保单号
        payNumber: "1", // 期数；1首期；2续期
        insuredAmount: "", // 保额
        orgId: "", // 出单机构id
        orgName: "", // 出单机构名称
        groupId: "", // 出单团队
        salesmanId: "", // 业务员id
        salesmanName: "", // 业务员名称
        phoneNum: "", // 出单业务员手机号
        status: "", // 保单状态
        insureTime: "", // 承保日期
        refundFee:"",// 退保保费
        reason: "", // 退保原因
        verifyTime: "", // 回访日期
        verifyStatus: "", // 回访状态
        effectTime: "", // 生效日期
        receiptDate: '', // 回执回销日期
        hesitateTime: "", // 犹豫期截止日
        holdTime: "", // 投保日期
        payTime: "", // 支付日期
        returnTime: "", // 退保日期
        endTime: "", // 终止日期
        payType: "", // 交费方式
        payLimit: "", // 交费期限数字
        payment: "1", //交费期限单位
        guaranteeLimit: "", // 保障期限
        guaranteeType: "3", // 保障期限时间单位
        revokeDate: "", // 撤单日期
        refuseDate: "", // 拒保日期
        areaCode:[],// 区域
        includingDeath:'',// 是否含身故
        doubleRecordStatus:'',// 双录状态
        isSelfHold:'',// 是否自保件
        isMutualHold:'',// 是否互保件
        sellType:'',// 业务类型
        sellResource:'',// 业务来源
        helpUserId:'',// 协同人id
        area:''
      },
      // 附加险
      disabledAdditional: [],
      formDynamic: {
        additional: [

        ],
      },
      //投保人
      policyHoderForm: {
        holderId: "", // 投保人Id
        holderName: "", // 投保人
        holderIdType: "", // 证件类型
        holderIdNo: "", // 投保人证件号
        holderSex: "", //投保人性别
        holderBirth: "", // 投保人出生日期
        holderIncome: "", // 年收入
        holderMobile: "", // 投保人电话
        holderEmail: "", // 投保人邮箱
        holderJob: "", // 职业
        holderAddress: "", // 投保人详细地址
        term: "", // 有效期
        lifelong: false, // 终身
        height: '', // 身高cm
        weight: '', // 体重kg
        hasSocialInsurance: '', // 有无社保
        familyRelationShip: '', // 家庭关系
        holderRegion: '', // 联系地址
        regionCode: [], // 联系地址code
      },
      // 被保险人
      insuredFormDynamic:{
        insuredForm: [{
          id: "", //被保险人id，
          infoType: '', //信息类型1投保人2被保险人
          name: "", // 被保险人姓名
          idType: "", // 被保险人证件类型1身份证2护照3军人证4其它5户口本6出生证
          idNo: "", // 被保险人证件号
          validPeriod:'',// 证件有效期
          sex: "", // 被保险人性别
          age: "", // 被保险人年龄
          birth: "", // 被保险人出生日期
          holderRelation: "", // //与投保人的关系1本人2父母3子女4配偶
          income: "", // 被保险人年收入
          mobile: "", // 被保险人电话
          job: "", // 被保险人职业
          email: "", // 邮箱
          address: "", // 被保险人详细地址
          bank:'', //开户行
          cardNo:'',//卡号
          createTime: '',
          updateTime: '',
          createBy: '',
          updateBy: '',
          term: "", // 有效期
          lifelong: false, // 有效期-终身
          height: '', // 身高cm
          weight: '', // 体重kg
          hasSocialInsurance: '', // 有无社保
          familyRelationShip: '', // 家庭关系
          region: '', // 联系地址
          regionCode: [], // 联系地址code
          rights1:[
            {
              name:'',
              content:'',
              quota:'',
            }
          ], // 保障权益
          rights:''
        }]
      },
      //受益人
      beneficiaryType: "1", // 受益人类型
      benefitFormDynamic: {
        benefitForm: [
          {
            // benefitType:'2', // 受益人类型
            name: "", // 受益人姓名
            insuranceRelation: "", // 与被保险人关系
            idType: "", // 受益人证件类型
            idNo: "", //受益人证件号
            sex: "", //受益人性别
            birth: "", //受益人出生日期
            benefitScale: "", // 受益比例
            benefitOrder: "", // 收益顺序
            mobile: "", // 受益人手机号
            email: "", // 受益人邮箱
          },
        ],
      },
      accountForm: {
        bank: "", //开户行
        cardNoName: "", //银行卡户名
        account: "", //银行账户
      },
      formDataValidate: {
        isAbnormal: [
          { required: true },
        ],
        companyCode: [
          { required: true, message: "请选择保险公司", trigger: "change" },
        ],
        productCode: [
          { required: true, message: "请选择保司产品", trigger: "change" },
        ],
        mainFee: [
          { required: true, message: "保费不能为空", trigger: "blur" },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ],
        policyNo: [
          { required: true, message: "保单号不能为空", trigger: "blur" },
        ],
        // payNumber: [{ required: true }],
      },
      // 附加险验证
      additionRules: {
        productId:[
          {
            required: true,
            message:'请选择产品',
            trigger:'change'
          }
        ],
        fee: [
          {required: true,message: "保费不能为空", trigger: "blur"},
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], 
      },
      // 投保人信息
      policyHoderValidate: {
      },
      // 被保险人信息验证
      insuredFormValidate: {
        income: [
          {
            required:false,
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              if(!value){
                return
              }
              return Number(value);
            },
            trigger:"blur"
          },
        ],
      },
      // 受益人信息验证
      benefitValidate: {
      },
      // 被保人权益信息
      rightsValidate:{
        // name:[{required:true,message:'权益名称不能为空',trigger:'blur'}],
        // quota:[
        //   {required:true,message:'保障额度不能为空', trigger: "blur" },
        //   {
        //     type: "number",
        //     message: "输入的类型为数字",
        //     transform(value) {
        //       return Number(value);
        //     }
        //   }
        // ],
        // content:[
        //   {
        //     required:true,
        //     message:'保障内容不能为空',
        //     trigger:'blur'
        //   }
        // ]
      }
    };
  }
};
